import { httpClient } from '@/lib/api';
import type { DashboardData, DashboardSection } from '../types';

export interface DashboardFilters {
  section: DashboardSection;
  from?: string;
  to?: string;
  ownerId?: string;
}
export const dashboardApi = {
  get: (filters: DashboardFilters): Promise<DashboardData> =>
    httpClient.get('/dashboard', { query: { ...filters } }),
  owners: (): Promise<{ id: string; label: string }[]> => httpClient.get('/dashboard/owners'),
};
